module.exports = __webpack_public_path__ + "img/iGoalLogo.82603c27.png";